jQuery(document).ready(function(){
    let el = document.getElementById("lg-copyright-current-year");
    el.innerText = new Date().getFullYear();
});
